import { LoadInPageProps, LoadInPage as BaseLoadInPage } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

export const LoadInPage: FunctionComponent<LoadInPageProps> = (props) => (
  <BaseLoadInPage
    spinnerProps={{
      css: {
        position: 'fixed',
        top: `calc(50% - 2.5rem)`,
        left: 'calc(50% - 2.5rem)',
      },
      $size: '5rem',
    }}
    {...props}
  />
);
